module.exports = __webpack_public_path__ + "static/ovo-20897282fa83ec1b2cd99b782720bd0d.svg";